<template>
  <div class="container">
    <v-card>
      <v-card-title class="blue accent-1 gray--text">Stock de Bins por Planta</v-card-title>
      <v-card-text>
        <v-row class="mx-1">
          <v-col cols="4">
            <v-btn @click="download" color="primary">Excel</v-btn>
          </v-col>
        </v-row>
        <v-data-table 
          :headers="stockFacilityListHeaders"
          :items="stockFacilityListBody"
          class="elevation-1"
          no-data-text="No hay datos"
          :hide-default-footer="true"
          disable-pagination
          fixed-header
          :height="table_height"
        >
          <template slot="body.append">
            <tr class="primary--text">
              <th class="title text-center">Totales</th>
              <th class="title text-center" v-for="p in cols" :key="p">
                  {{ sumaColumna('val'+p) }}
              </th>
              <th class="title text-center">
                  {{ sumaColumna('total') }}
              </th>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex'

  export default {
    data: () => ({
      cols: 0,
      url_excel: '',
      isLoading: false,
      stockFacilityListHeaders: [],
      stockFacilityListBody: [],
      table_height: 600,
    }),
    mounted() {
      this.loadFacilityStockReport();
    },
    methods:{
      sumaColumna(key) {
        let total = 0;
        this.stockFacilityListBody.forEach(row => {
          total += parseInt(row[key]);
        });
        return total;
      },
      async loadFacilityStockReport(){
        this.mostrarLoading('Generando informe, por favor espere...');
        let url = `${this.base_url}bins/report/facility/-1`;
        await this.axios.get(url, this.headers).then((response)=>{
          this.stockFacilityListHeaders = response.data.data.headers;
          this.stockFacilityListBody = response.data.data.body;
          this.url_excel = this.storage_url + response.data.data.url_excel;
          this.cols = response.data.data.cols;
          this.ocultarLoading();
        }).catch((error)=>{
          console.log(error);
          this.ocultarLoading();
        });
      },
      download(){
        window.location.href = this.url_excel;
      },
      ...mapMutations(['actualizarBaseUrl', 'actualizarUrlStorage', 'mostrarLoading', 'ocultarLoading']),
    },
    computed:{
      ...mapState(['authenticated', 'loading', 'base_url', 'storage_url', 'headers'])
    },
    components:{
      
    }
  }
</script>